"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SSN_REGEX = /^(\d{3})-(\d{2})-(\d{4})$/;
exports.Validator = {
    name: "ssn",
    errorMessage: "Entered value is not valid Social Security Number.",
    validate: function (value) { return SSN_REGEX.test("" + value); },
};
